module.exports = __webpack_public_path__ + "img/68.63ec2cee.jpg";